import { $api } from "../generated/client";
import { SearchReturnRequestsResponseDto } from "../generated/schema";
import { SESSION_TOKEN_KEY } from "./use-session-token";

export type UseOrderReturnRequestsParams = {
  shopSlug: string;
  orderId: string;
};

export function useOrderReturnRequests<T = SearchReturnRequestsResponseDto>({
  // ??!!! should we really need the shop slug here ?
  shopSlug,
  orderId,
  select,
}: UseOrderReturnRequestsParams & {
  select?: (data: SearchReturnRequestsResponseDto) => T;
}) {
  return $api.useSuspenseQuery(
    "get",
    "/public/return-request/search",
    {
      params: {
        query: { orderId, shopSlug },
        header: {
          authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}`,
          Accept: "application/json",
        },
      },
    },
    { select: select! },
  );
}

export type UseOrderReturnRequestParams = UseOrderReturnRequestsParams & {
  returnRequestId: string;
};

export function useOrderReturnRequest<
  T = SearchReturnRequestsResponseDto["returnRequests"][number],
>({
  returnRequestId,
  select,
  ...params
}: UseOrderReturnRequestParams & {
  select?: (
    data: SearchReturnRequestsResponseDto["returnRequests"][number],
  ) => T;
}) {
  return useOrderReturnRequests({
    ...params,
    select: (data) => {
      const returnRequest = data.returnRequests.find(
        (rr) => rr.id === returnRequestId,
      );
      if (!returnRequest) {
        throw new Error(
          `Return request with id ${returnRequestId} not found for order ${params.orderId}`,
        );
      }
      return select ? select(returnRequest) : (returnRequest as T);
    },
  });
}
